import { render, staticRenderFns } from "./GrantCardDetail.vue?vue&type=template&id=47462db6"
import script from "./GrantCardDetail.vue?vue&type=script&lang=js"
export * from "./GrantCardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports